var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack514({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.69,7.06H7.8a3.83,3.83,0,0,1,1.09.11,1.85,1.85,0,0,1,.87.52,2.45,2.45,0,0,1,.54.93A4.11,4.11,0,0,1,10.49,10a3.65,3.65,0,0,1-.18,1.22,2.36,2.36,0,0,1-.61,1,2,2,0,0,1-.81.46,3.56,3.56,0,0,1-1,.12H5.69ZM6.85,8v3.8h.86a2.89,2.89,0,0,0,.7-.06,1,1,0,0,0,.47-.24,1.22,1.22,0,0,0,.3-.55,3.65,3.65,0,0,0,.11-1.05,3.43,3.43,0,0,0-.11-1,1.35,1.35,0,0,0-.33-.55,1.15,1.15,0,0,0-.54-.27A4.67,4.67,0,0,0,7.37,8Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack514);
export default __webpack_public_path__ + "static/media/Symbolpack_5_14.bb56b50a788505887835ad45658b5c8f.svg";
export { ForwardRef as ReactComponent };